import React from "react";

import slugify from "slugify";

import { Box, Flex, Link, Text } from "./base";

const TagList = ({
  tags,
  title = "Tags",
  color = "white",
  bg = "blue",
  root = "/",
}) => (
  <Box>
    <Text textTransform="uppercase" fontWeight="bold">
      {title}
    </Text>
    <Flex mt={2} wrap="wrap">
      {tags.map(tag => {
        const slug = slugify(tag, {
          lower: true,
        });

        return (
          <Link
            bg={bg}
            key={slug}
            py={1}
            px={2}
            mr={2}
            mb={2}
            color={color}
            to={`${root}${slug}`}
            textDecoration="none"
          >
            {tag}
          </Link>
        );
      })}
    </Flex>
  </Box>
);

export default TagList;



// WEBPACK FOOTER //
// ./src/components/TagList.js